import PropTypes from "prop-types";
import React from "react";

// ^^ A Link element for our custom history router.
import { faCheck as farCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./style.scss";

class CheckboxSet extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovering: {},
    };

    this.vars = {
      //
    };

    this.elRefs = {
      //
    };
  }

  componentDidMount() {
    // this.timerID = setInterval(() => this.tick(), 1000);

    this.init();
  }

  componentWillUnmount() {
    // clearInterval(this.timerID);
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    /* if (this.props.currentRoute !== prevProps.currentRoute) {
            Z.loadPage();
        } */
  }

  init = () => {
    const Z = this;

    Z.initFieldValue();
  };

  initFieldValue = () => {
    const Z = this;

    if (Z.props.updateFormValue != null) {
      const initValue = Z.props.multi ? [] : null;

      Z.props.updateFormValue({
        fieldName: Z.props.name,
        fieldValue: initValue,
        fieldType: "CheckboxSet",
        fieldRequired: Z.props.required,
      });
    }
  };

  updateCheckboxValue = ({ event, name, value }) => {
    const Z = this;

    var target, valueActive;
    if (event != null && event.target.type == "checkbox") {
      target = event.target;
      valueActive = target.checked;
    } else {
      target = Z.elRefs[name];
      if (target) {
        valueActive = !target.checked;
      }
    }

    if (value !== null) valueActive = value;

    var currentValue;

    if (Z.props.multi) {
      currentValue = Z.props.formValues[name] ?? []; // [23498789, 234934589390]
      const valueIndex = currentValue.indexOf(value);
      if (valueIndex > -1) {
        currentValue.splice(valueIndex, 1);
      }
      if (valueActive) currentValue.push(value);
    } else {
      currentValue = Z.props.formValues[name]; // 23498789
      if (valueActive !== null) currentValue = value;
      if (Z.props.formValues[name] == currentValue) currentValue = null;
    }

    if (Z.props.updateFormValue != null) {
      Z.props.updateFormValue({
        fieldName: name,
        fieldValue: currentValue,
        fieldType: "CheckboxSet",
        fieldRequired: Z.props.required,
      });
    }
  };

  onLabelClick = (item) => {
    const Z = this;

    // console.log("LABEL click - item:", item);
    Z.updateCheckboxValue({ name: Z.props.name, value: item.value });
  };

  onLabelHover = ({ hovering, value }) => {
    const Z = this;

    Z.setState((state) => {
      state.hovering[value] = hovering;
      return { hovering: state.hovering };
    });
  };

  render() {
    var Z = this;

    return (
      <div className={`CheckboxSet ${Z.props.formErrors[Z.props.name] != null && Z.props.formErrors[Z.props.name] != false ? "error" : ""}}`}>
        <div className="checkbox-set-title">{Z.props.title}</div>

        {Z.props.items.map((item, itemIndex) => {
          var setValue,
            isChecked = false;

          if (Z.props.multi) {
            setValue = Z.props.formValues[Z.props.name] ?? [];
            isChecked = setValue.indexOf(item.value) > -1;
          } else {
            setValue = Z.props.formValues[Z.props.name];
            isChecked = setValue == item.value;
          }

          // console.log("CHECKBOX - item:", item);

          return (
            <div className={`checkbox-item ${Z.state.hovering[item.value] == true ? "hover" : ""}`} key={`${item.name}-${item.value}`}>
              <div className="checkbox-input-wrap">
                <input
                  type="checkbox"
                  className="checkbox-input"
                  ref={(el) => (Z.elRefs[item.value] = el)}
                  name={Z.props.name}
                  value={item.value}
                  checked={isChecked}
                  onChange={(event) =>
                    Z.updateCheckboxValue({
                      event: event,
                      name: Z.props.name,
                      value: item.value,
                    })
                  }
                />
                <div className={`checkbox-cover ${Z.props.multi ? "" : "radio-cover"}`}>
                  {Z.props.multi ? <FontAwesomeIcon icon={farCheck} className="checkmark" /> : <div className="checkmark"></div>}
                </div>
              </div>
              <div
                className="checkbox-item-label"
                onClick={() => Z.onLabelClick(item)}
                onMouseEnter={() => Z.onLabelHover({ hovering: true, value: item.value })}
                onMouseLeave={() => Z.onLabelHover({ hovering: false, value: item.value })}
              >
                {item.label}
              </div>
            </div>
          );
        })}

        {/* // Leaving this here in case we enable "required" on any checkboxes later:
        <div
          className={`field-error ${
            Z.props.formErrors[Z.props.name] != null &&
            Z.props.formErrors[Z.props.name] != false
              ? "active"
              : ""
          }`}
        >
          {Z.props.formErrors[Z.props.name] == true
            ? "This field is required."
            : `${Z.props.formErrors[Z.props.name]}`}
        </div> */}
      </div>
    );
  }
}

CheckboxSet.propTypes = {
  name: PropTypes.string,
  multi: PropTypes.bool,
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object),
  formValues: PropTypes.object,
  formErrors: PropTypes.object,
  updateFormValue: PropTypes.func,
  // required: PropTypes.any,
};

export default CheckboxSet;
